export const onboardingContent = {
  title: 'Blueprint の使い方',
  sections: [
    {
      heading: 'ここでは何をする？',
      body: 'プロジェクトは要件定義の単位です。打ち合わせのヒアリングメモを入力すると、概念モデル・要求・要件・業務フロー・権限マトリクスなどが自動的に構造化されます。'
    },
    {
      heading: 'どういうやって診断する？',
      body: '議事録に書かれた内容の裏にある「なぜ」を要求として抜き出し、データモデルとして矛盾なく繋がっているかを検証します。書かれていない論点や接続の甘い箇所を、リスクとして可視化します。'
    },
    {
      heading: 'どんなアウトプットが出る？',
      body: '概念モデル・要求一覧・要件一覧・業務フロー・権限マトリクス・リスク一覧・未解決質問一覧の7つの成果物と、リスク密度に基づく品質診断が得られます。この成果物と診断は、実際にシステム開発で行われている手法を元にしています。'
    },
    {
      heading: '次のステップ',
      body: 'プロジェクトを開き、「要件ヒアリング」からメモを入力してください。'
    }
  ]
}
